<mat-form-field [@.disabled]="true" style="width: 60%; display:flex; margin-left: auto;">
    <mat-select [@.disabled]="true" [(ngModel)]="selectedLang" (selectionChange)="onLanguageChange()">
      <mat-select-trigger style="display:flex; place-items:center; gap:5px;">
        <mat-icon style="opacity: 0.7;">language</mat-icon> {{selectedLangLabel}}
      </mat-select-trigger>
      <mat-option *ngFor="let option of options" [value]="option.value">{{ option.label }}</mat-option>
    </mat-select>
</mat-form-field>
